import { GET_ILEGGELSE_HISTORIKK_SUCCESS } from "../actions/ileggelserActions";

const INITIAL_STATE = [];

export default function ileggelseHistorikkReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case GET_ILEGGELSE_HISTORIKK_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
